import { loadEosJsEcc } from 'src/app/global-state/services/javascript-loader';
import { generateNonce } from 'src/app/util/random-util';

declare var eosjs_ecc: any;

export async function createEosSignature<T>(inputData: T, privateKey: string) {
  // load eosjs_ecc
  await loadEosJsEcc();

  const nonce = generateNonce();

  const dataToSign = {
    ...inputData,
    nonce,
  };

  const input = JSON.stringify(dataToSign);

  const signature: string = eosjs_ecc.sign(input, privateKey);

  return {
    input,
    signature,
    nonce,
    isSignedDataHashed: false,
  };
}

export async function getPublicKeyFromPrivateKey(
  privateKey: string
): Promise<string> {
  // load eosjs_ecc
  await loadEosJsEcc();

  return eosjs_ecc.privateToPublic(privateKey);
}
